import { InjectionToken } from '@angular/core'

export type UserManagementContext = 'navix-admin' | 'tenant-admin'

export const USER_MANAGEMENT_CONTEXT = new InjectionToken<UserManagementContext>(
  'USER_MANAGEMENT_CONTEXT',
  { providedIn: 'root', factory: () => 'navix-admin' }
)
